import { TranslateService } from '@ngx-translate/core';

const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;

// "5 min ago", "3h ago", "2d ago"; null for less than a minute, which the caller words itself.
export function relativeAge(translate: TranslateService, then: Date, now: Date): string | null {
  const minutes = Math.max(0, Math.round((now.getTime() - then.getTime()) / 60_000));
  if (minutes < 1) return null;
  if (minutes < MINUTES_PER_HOUR) {
    return translate.instant('recentlyUsed.minutesAgo', { value: minutes });
  }
  const hours = Math.floor(minutes / MINUTES_PER_HOUR);
  if (hours < HOURS_PER_DAY) return translate.instant('recentlyUsed.hoursAgo', { value: hours });
  return translate.instant('recentlyUsed.daysAgo', { value: Math.floor(hours / HOURS_PER_DAY) });
}
